<template>
    <div class="animated fadeIn content-holder">
        <b-card no-body>
            <b-card-header class="custom-header">
                <div><i class="icon-note"></i>Analytics Graph{{ graph_id ? " - Edit" : " - New"}}</div>
                <b-button-group>
                    <router-link :to="`/analytics`" class="link">
                        <b-button class="custom-cancel"><i class="fa fa-times text-danger"></i> Cancel
                        </b-button>
                    </router-link>
                    <b-button v-on:click="post('andClose')" :disabled="disabled || submitted"><i class="fa fa-save"></i> Save & Close</b-button>
                    <b-button v-on:click="post()" :disabled="disabled"><i class="fa fa-check text-success "></i> Apply</b-button>
                </b-button-group>
            </b-card-header>
    
            <b-card-body>
                <b-row>
                    <b-col md="10">
                        <b-card>
    
                                    <b-card-body>
                                        <b-row>
                                            <b-col md="6">
                                                <!-- Analytics Name -->
                                                <b-form-group label="Graph Name" label-for="graphName">
                                                    <b-form-input id="graphName" type="text" v-model.lazy.trim="$v.form.graphName.$model" :state="chkState('graphName')" placeholder="Name" autofocus />
                                                    <b-form-invalid-feedback>
                                                        This is a required field and must be at least 2 characters
                                                    </b-form-invalid-feedback>
                                                </b-form-group>
                                            </b-col>
    
                                            <b-col md="6">
                                                <b-form-group label="Graph Type" label-for="graphType">
                                                    <v-select id="graphType" size="lg" :plain="true" :options="datatype" v-model.lazy.trim="$v.form.graphType.$model" :state="chkState('graphType')" @input="handleChangeDataSource($event)" placeholder="Choose one or more...">
                                                    </v-select>
                                                </b-form-group>
                                            </b-col>
                                        </b-row>
    
                                        <b-row>
                                            <b-col md="12">
                                                <!-- Descriotion -->
                                                <b-form-group>
                                                    <label for="description">Description</label>
                                                    <vue-editor v-model.lazy.trim="$v.form.description.$model"></vue-editor>
                                                </b-form-group>
                                            </b-col>
                                        </b-row>
                                    </b-card-body>
                               
                        </b-card>
                    </b-col>
    
                    <b-col md="2" class="">
                        <b-card>
                            <!-- Active -->
                            <label id="published" class="d-block">
                                  Active&nbsp;
                                </label>
                            <c-switch class="mx-1" data-on="" data-off="" dataOn="" dataOff="" color="success" :checked="active" label v-model.lazy.trim="active" />
                        </b-card>
                    </b-col>
    
                </b-row>
                
            </b-card-body>
        </b-card>
        <b-card no-body  v-if="isShowGraph" >
            <b-card-body id="showGraph">
                     <b-row>
                        <b-col sm="12">
                            <h4 class="card-title mb-0">{{title}}</h4>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col md="8"></b-col>
                        <b-col md="1">
                            <b-form-group label-for="count">
                                <v-select id="count" size="lg" :plain="true" 
                                :options="dataCount" 
                                v-model="count"
                                @input="handleChangeDataSource($event)"
                                >
                                </v-select>
                            </b-form-group>
                        </b-col>
                        <b-col md="3">
                            <b-form-group label-for="time">
                                <v-select id="time" size="lg" :plain="true" :options="dataShow" v-model="time" @input="handleChangeDataSource($event)" placeholder="Choose one">
                                </v-select>
                            </b-form-group>
                        </b-col>
                    </b-row>
               <b-col md="6">
                    <barChart v-if="barChart" ref="barChart" ></barChart>
                    <pieChart v-if="pieChart" ref="pieChart"></pieChart>
                </b-col>
                <b-col md="12">
                    <lineChart v-if="lineChart" ref="lineChart"></lineChart>
                    <mapChart v-if="mapChart" ref="mapChart"  class="chart-wrapper"></mapChart>
                </b-col>
            </b-card-body>
        </b-card>
        
    
        <!-- Modal Component -->
        <div>
            <Modals ref="form"></Modals>
        </div>
    
    
    </div>
</template>

<script>
import Vue from 'vue';
import { validationMixin } from "vuelidate";
import { required, minLength, email, sameAs, helpers } from "vuelidate/lib/validators";
import { Switch as cSwitch } from '@coreui/vue';
import { router } from '../../router/index';
import { mapState, mapActions } from 'vuex';
import VueNotifications from 'vue-notifications';
import miniToastr from 'mini-toastr';
import { apigClient } from '@/shared/api';
import { cipher } from '@/shared/cipher';
import { userPool } from '@/shared/cognito';
import ActivityLog from '@/containers/ActivityLog';
import { ClientTable, Event } from 'vue-tables-2'
import Modals from "@/shared/Modals.vue";
import { timezones } from '@/shared/helper';
import vSelect from "vue-select";
import { VueEditor } from "vue2-editor";

//components graph
import lineChart from '../graphDynamic/lineChart';
import pieChart from '../graphDynamic/pieChart';
import barChart from '../graphDynamic/barChart';
import mapChart from '../graphDynamic/mapChart';
// import { format } from 'path';

const Spinner = () =>
    import ('../shared/Spinner');
const toastTypes = {
    success: 'success',
    error: 'error',
    info: 'info',
    warn: 'warn'
}
miniToastr.init({ types: toastTypes })

function toast({ title, message, type, timeout, cb }) {
    return miniToastr[type](message, title, timeout, cb)
}
const options = {
    success: toast,
    error: toast,
    info: toast,
    warn: toast
}
Vue.use(VueNotifications, options);
Vue.use(ClientTable);
const strongPass = helpers.regex('strongPass', /(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}/)
const formShape = {
    graphName: "",
    graphType: null,
    description: "",
    published: null,
    systemReport: null,
}
let validations = {
    form: {
        graphName: {
            required: true,
             minLength: minLength(2)
        },
        graphType: {
            required: true,
        },
        description: {
            required: true,
        },
        published: {
            required: true
        },
        systemReport: {
            required: true
        },

    }
}
export default {
    name: "Analytics",
    components: {
        cSwitch,
        Spinner,
        vSelect,
        VueEditor,
        Modals,
        lineChart,
        pieChart,
        mapChart,
        barChart,
    },
    data() {
        if (window.location.href.includes("/analytics/graph/edit")) {
            var graph_id = localStorage.getItem('page_graph_id');
        }
        return {
            loginUserInfo: JSON.parse(localStorage.getItem('loginUserInfo')),
            form: Object.assign({}, formShape),
            feedBack: 'secondary',
            submitted: false,
            disabled: true,
            isLoading: true,
            isShowGraph:false,
            ischart:false,
            lineChart:false,
            pieChart:false,
            barChart:false,
            mapChart:false,

            graph_id: graph_id || null,
            active:true,
            published: null,
            systemReport: null,
            graphType:[],
            datatype:[],
            selectedForm: 'basicInfo',
            modalMergeOpen: false,
            
            published: null,
            systemReport: null,

            // Data graph
            title: null,
            count: {value:10,label:"10"},
            time: {
                value:"M",
                label:"Month",
                format:"YYYY-MM",
            },
            dataCount:[
                { value: 5, label: '5' },
                { value: 10, label: '10' },
                { value: 12, label: '12' },
                { value: 15, label: '15' }],
            dataShow:[
                { value: "days", label: "Days", format: "YYYY-MM-DD"},
                { value: "M", label: "Mont", format: "YYYY-MM" },
                { value: "Y", label: 'Year', format: "YYYY" }],
        }
    },
    mounted: function() {
        if (this.graph_id) {
             setTimeout(()=>{
                this.loadData();
            
            
        },100);
        }
        this.getGraphType();
    },
    computed: {
        formStr() { return JSON.stringify(this.form, null, 4) },
        isValid() { return !this.$v.form.$anyError },
        isDirty() { return this.$v.form.$anyDirty },
    },
    mixins: [validationMixin],
    validations: validations,
    methods: {
        handleChangeDataSource: function() {
            let graphType = this.$v.form["graphType"].$model;
            // let that = this;
            this.loadChart(graphType);
        },
        routerBack() {
            this.$router.go(-1);
        },
        onSubmit() {
            if (this.validate()) {
                this.$nextTick(() => {
                    this.submitted = true
                    this.feedBack = 'info'
                })
            }
        },
        chkState(val) {
            const field = this.$v.form[val];
            let graphName = this.$v.form["graphName"];
            let basicFieldsInvalid = (graphName.$model !== undefined && graphName.$model !== '')
            this.disabled = !basicFieldsInvalid;
            return (field.$model !== '' && field.$model !== undefined) ? !field.$dirty || !field.$invalid : null;
        },
        loadData: function() {
            var method = 'GET';
            var pathTemplate = '/graph/' + this.graph_id;
            var additionalParams = {};
            var pathParams = {};
            var that = this;
            apigClient.invokeApi(pathParams, pathTemplate, method, additionalParams)
                .then(function(results) {
                    if (results.data.status) {
                        var datas = results["data"]["data"];
                        that.form.id = datas.id;
                        that.form.graphName = datas.graphName;
                        that.form.graphType = datas.graphType;
                        that.form.description = datas.description;
                        that.form.active = datas.active;
                    } else {
                        that.showErrorMsg({ message: result.data.message });
                    }
                    that.isLoading = false;
                }).catch(function(error) {
                    that.showErrorMsg({ message: error.message });
                    that.isLoading = false;
                });
        },
        getGraphType() {
            this.datatype = [
                { value: 'line', label: 'Line Chart' },
                { value: 'pie', label: 'Pie Chart' },
                { value: 'bar', label: 'Bar Chart' },
                { value: 'map', label: 'Map Chart' }
                ];
        },
        assignCurrentTab(value) {
            this.currentTab = value;
        },
        loadChart(event){
            this.isShowGraph = true;

        if (event.value == 'line') {
            this.title = 'Line Chart'
            this.lineChart = true;
            this.barChart = false;
            this.pieChart = false;
            this.mapChart = false;
            setTimeout(()=>{
                this.$refs.lineChart.getChartData(this.count,this.time);
            },500)
        }else if(event.value == 'bar'){
            this.title = 'Bar Chart'
           this.lineChart = false;
            this.barChart = true;
            this.pieChart = false;
            this.mapChart = false;
            setTimeout(()=>{
             this.$refs.barChart.getChartData(this.count,this.time);
              },500)
        }else if(event.value == 'pie'){
            this.title = 'Pie Chart'
            this.lineChart = false;
            this.barChart = false;
            this.pieChart = true;
            this.mapChart = false;
            setTimeout(()=>{
             this.$refs.pieChart.getChartData(this.count,this.time);
              },500)
        }else if(event.value == 'map'){
            this.title = 'Map Chart'
            this.lineChart = false;
            this.barChart = false;
            this.pieChart = false;
            this.mapChart = true;
            setTimeout(()=>{
             this.$refs.mapChart.initMap(this.count,this.time);
              },500)
        }else{
            console.log(event.value);
        }
          
           
          
        },
        post: function(option) {
            let that = this;
            let nodata = null;
            let body = {
                graphName: that.form.graphName || nodata,
                graphType: that.form.graphType || nodata,
                description: that.form.description || nodata,
                active: that.active || nodata,
            }
            if (false) {} else {
                if (that.graph_id) {
                    this.$refs.form.openModal();
                    that.changeModalContent(
                        "loading",
                        "Updating...",
                        "Updating Analytics Info"
                    );
                    var method = 'PUT';
                    var pathTemplate = '/graph/' + that.graph_id;
                    var additionalParams = {};
                    var pathParams = {};
                    apigClient.invokeApi(pathParams, pathTemplate, method, additionalParams, body)
                        .then(function(result) {
                            console.log('update a graph, graph_id: ' + that.graph_id);
                            // that.showSuccessMsgCreate();
                            that.changeModalContent(
                                "success",
                                "Updated success!",
                                "The graph data has been updated"
                            );
                           setTimeout(() => {
                            that.$refs.form.closeModal();
                            }, 2000);
                            if (option == "andClose") {
                                setTimeout(() => {
                                    that.routerBack();
                                }, 2000)
                            }
                        }).catch(function(result) {
                            // that.showErrorMsg();
                            that.changeModalContent(
                                "error",
                                "Error Occured!",
                                "Error From API Endpoint: " + result.data.message
                            );
                        });
                } else {
                    this.$refs.form.openModal();
                    var method = 'POST';
                    var pathTemplate = '/graph';
                    var additionalParams = {};
                    var pathParams = {};
                    apigClient.invokeApi(pathParams, pathTemplate, method, additionalParams, body)
                        .then(function(result) {
                            console.log('create a new analytic, analytic_id: ' + result["data"]["data"]);
                            if (option == "andClose") {
                                localStorage.setItem('page_analytic_id', result["data"]["data"]);
                                that.changeModalContent(
                                    "success",
                                    "Updated success!",
                                    "The Analytics data has been created"
                                );
                                setTimeout(() => {
                                    that.routerBack();
                                }, 2000)
                            }
                        }).catch(function(result) {
                            console.log(result);
                            // that.showErrorMsg();
                            that.changeModalContent(
                                "error",
                                "Error Occured!",
                                "Error From API Endpoint: " + result
                            );
                        });
                }
                this.isLoading = false;
            }


        },
        // set modal
        changeModalContent(status = null, title = null, message = null) {
            let that = this;
            that.$refs.form.status = status ? status : that.$refs.form.status;
            that.$refs.form.title = title ? title : that.$refs.form.title;
            that.$refs.form.message = message ? message : that.$refs.form.message;
        },

    },
    notifications: {
        showSuccessMsgCreate: {
            type: VueNotifications.types.success,
            title: 'Operation successfull!',
            message: 'The Analytic data has been create'
        },
        showSuccessMsgUpdate: {
            type: VueNotifications.types.success,
            title: 'Operation successfull!',
            message: 'The Analytic data has been update'
        },
        showInfoMsg: {
            type: VueNotifications.types.info,
            title: 'Info',
            message: 'Here is some info for you'
        },
        showWarnMsg: {
            type: VueNotifications.types.warn,
            title: 'Warning',
            message: 'That\'s the kind of warning'
        },
        showErrorMsg: {
            type: VueNotifications.types.error,
            title: null,
            message: ''
        }
    },
}
</script>



<style scoped>
.bar-chart{
     height: 32em !important;
}
#map {
    height: 32em;
}

.btn.disabled {
    cursor: auto;
}

.custom-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.btn-group>.btn,
.btn-group-vertical>.btn {
    border: 1px solid #a4acb5;
}

@media only screen and (max-width: 600px) {
    .custom-header {
        flex-direction: column;
        align-items: inherit;
    }
    .custom-header>div:first-child {
        margin-bottom: 10px;
    }
}

.custom-cancel {
    border-radius: 0.25rem 0 0 0.25rem;
}

.sk-fading-circle .sk-circle {
    margin: 0 auto;
}

.sk-three-bounce {
    height: 40px;
}

label {
    font-weight: 600 !important;
}
</style>

<style>
#language {
    margin-top: 15px;
}

.custom-header {
    display: flex;
    justify-content: space-between;
}

select {
    /* for Firefox */
    -moz-appearance: none;
    /* for Chrome */
    -webkit-appearance: none;
}

/* For IE10 */

select::-ms-expand {
    display: none;
}

.tech-image {
    height: 15px;
}

.form-group label.required:after {
    content: " *";
    color: #f86b4f;
}

.color-20a8d8 {
    color: #20a8d8;
}

.underline {
    text-decoration: underline;
}

.font-size-13 {
    font-size: 13px !important;
}

.color-red {
    color: red;
}

.margin-bottom-5 {
    margin-bottom: 5px;
}

.subject-info-box-1,
.subject-info-box-2 {
    float: left;
    width: 45%;
}

select {
    height: 15em !important;
    padding: 0;
}

select option:hover {
    background: #EEEEEE;
}

.subject-info-arrows {
    float: left;
    width: 10%;
}

input {
    width: 70%;
    margin-bottom: 5px;
}

.btn-default {
    border: 1px solid #c8ced3;
    border-radius: 0.25rem;
    width: 40px;
}

.btn-default:hover {
    border: 1px solid #80c1d0;
    border-radius: 0.25rem;
    width: 40px;
}
</style>

